import './theme/_sponsor-slider.scss';

$(() => {
  const scroller = new IntersectionObserver(cardGroups => {
    cardGroups.forEach(cardGroup => {
      const $el = $(cardGroup.target);
      if (cardGroup.isIntersecting) {
        if($el.data('autoplay') === 1) {
          $el.slick('slickPlay');
        }
      } else {
        $el.slick('slickPause');
        $el.slick('slickGoTo', 0);
      }
    });
  });
  
  $('.scc-sponsor-slider > .sponsorbar').each(function(){
    const $el = $(this);
    $el.slick({
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: $el.data('autoplay') === 1,
      infinite: $el.data('autoplay') === 1,
      autoplaySpeed: $el.data('autoplaySpeed'),
      prevArrow: '<span class="prev" aria-label="previous" role="button" tabindex="0"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8628 23.1429L0.5 12.0063L10.8628 0.857147L12.5 2.61658L3.77438 12.0063L12.5 21.3834L10.8628 23.1429Z" fill="#729333"/></svg></span>',
      nextArrow: '<span class="next" aria-label="next" role="button" tabindex="0"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.13719 0.857137L12.5 11.9937L2.13719 23.1429L0.5 21.3834L9.22562 11.9937L0.500002 2.61656L2.13719 0.857137Z" fill="#729333"/></svg></span>',
      customPaging : function(slider, i) {
        return $('<a role="button" aria-label="' + i + '" tabindex="0"/>');
      },
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
    $el.slick('slickPause');
    scroller.observe($el[0]);
  });
});
